import numeral from 'numeral';

export const validateAlphanumeric = (string) => {
  const re = /^[a-zA-Z0-9-\s,.]*$/;
  return re.test(string);
};

export const validateEmail = (email) => {
  const re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/; //eslint-disable-line
  return re.test(email);
};

export const formatMoney = (number) => `$${numeral(number).format('0,0.00')}`;

export const isIE = () => {
  return /*@cc_on!@*/false || !!document.documentMode;
}



// WEBPACK FOOTER //
// ./src/utils/helper.js